/* ==========================================================================
   Herb Angel Clean — theme.js
   Mobile nav, search modal, cart drawer, product gallery, FAQ, sticky header
   ========================================================================== */
(function () {
  'use strict';

  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const on = (el, evt, fn, opt) => el && el.addEventListener(evt, fn, opt);

  // ---------- Header scroll state ----------
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Mobile nav ----------
  const mobileNav  = $('.mobile-nav');
  const menuToggle = $('.menu-toggle');
  const mobileClose= $('.mobile-nav__close');
  const overlay    = $('#modal-overlay');
  on(menuToggle, 'click', () => {
    mobileNav && mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });
  const closeMobile = () => {
    mobileNav && mobileNav.classList.remove('is-open');
    overlay   && (overlay.classList.remove('is-open'), overlay.hidden = true);
    document.body.style.overflow = '';
  };
  on(mobileClose, 'click', closeMobile);
  on(overlay, 'click', () => { closeMobile(); closeSearch(); closeCart(); });

  // Mobile submenu toggle
  $$('.mobile-nav__toggle').forEach(btn => {
    on(btn, 'click', () => {
      const sub = btn.nextElementSibling;
      if (!sub) return;
      sub.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', sub.classList.contains('is-open'));
    });
  });

  // ---------- Search modal ----------
  const searchModal    = $('.search-modal');
  const searchInput    = $('.search-modal__form input');
  const searchBody     = $('.search-modal__body');
  const searchTriggers = $$('[data-search-trigger]');
  const searchCloseBtn = $('.search-modal__close');
  let searchTimer;

  const openSearch = () => {
    searchModal && searchModal.classList.add('is-open');
    overlay     && (overlay.hidden = false, overlay.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 50);
  };
  const closeSearch = () => {
    searchModal && searchModal.classList.remove('is-open');
    if (!mobileNav || !mobileNav.classList.contains('is-open')) {
      overlay && (overlay.classList.remove('is-open'), overlay.hidden = true);
      document.body.style.overflow = '';
    }
  };
  searchTriggers.forEach(el => on(el, 'click', openSearch));
  on(searchCloseBtn, 'click', closeSearch);
  on(document, 'keydown', e => { if (e.key === 'Escape') { closeSearch(); closeCart(); } });

  // Predictive search
  on(searchInput, 'input', () => {
    const q = searchInput.value.trim();
    clearTimeout(searchTimer);
    if (q.length < 2) {
      searchBody.innerHTML = '<div class="search-modal__hint">Type at least 2 characters to search.</div>';
      return;
    }
    searchTimer = setTimeout(() => fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
      .then(r => r.json())
      .then(data => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          searchBody.innerHTML = '<div class="search-modal__hint">No results found.</div>';
          return;
        }
        searchBody.innerHTML = products.map(p => `
          <a class="search-suggestion" href="${p.url}">
            <span class="search-suggestion__media">
              ${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}
            </span>
            <span>
              <span class="search-suggestion__title">${p.title}</span>
              <span class="search-suggestion__price">${p.price}</span>
            </span>
          </a>
        `).join('');
      })
      .catch(() => {
        searchBody.innerHTML = '<div class="search-modal__hint">Search is temporarily unavailable.</div>';
      }), 220);
  });

  // ---------- Cart drawer ----------
  const cartDrawer  = $('.cart-drawer');
  const cartTriggers= $$('[data-cart-trigger]');
  const cartCloseBtn= $('.cart-drawer__close');

  const openCart = () => {
    cartDrawer && cartDrawer.classList.add('is-open');
    overlay    && (overlay.hidden = false, overlay.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    cartDrawer && cartDrawer.classList.remove('is-open');
    if ((!mobileNav || !mobileNav.classList.contains('is-open')) &&
        (!searchModal || !searchModal.classList.contains('is-open'))) {
      overlay && (overlay.classList.remove('is-open'), overlay.hidden = true);
      document.body.style.overflow = '';
    }
  };
  cartTriggers.forEach(el => on(el, 'click', e => { e.preventDefault(); openCart(); }));
  on(cartCloseBtn, 'click', closeCart);

  // ---------- Cart line quantity ----------
  $$('.cart-line__qty button').forEach(btn => {
    on(btn, 'click', () => {
      const input = btn.parentElement.querySelector('input');
      let q = parseInt(input.value, 10) || 1;
      q = Math.max(0, btn.dataset.action === 'plus' ? q + 1 : q - 1);
      input.value = q;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ---------- Product gallery ----------
  const gallery = $('.product-gallery');
  if (gallery) {
    const main = $('#main-image', gallery);
    // Click main image to open full-resolution version
    if (main) on(main, 'click', () => {
      const z = main.dataset.zoom;
      if (z) window.open(z, '_blank');
    });
  }

  // ---------- Variant picker ----------
  const variantDataEl = document.getElementById('product-variants-data');
  const variantData = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
  const syncVariantImage = () => {
    const main = $('#main-image');
    if (!main || !variantData.length) return;
    const chosen = $$('.variant-picker').map(p => {
      const a = p.querySelector('.variant-picker__option.is-active');
      return a ? a.dataset.value : null;
    });
    const match = variantData.find(v => v.image && chosen.every((val, i) => v.options[i] === val));
    if (match) {
      main.src = match.image;
      if (match.zoom) main.dataset.zoom = match.zoom;
    }
  };
  $$('.variant-picker').forEach(picker => {
    const form  = picker.closest('form');
    const input = form ? $('input[type=hidden]', form) : null;
    const opts  = $$('.variant-picker__option', picker);
    opts.forEach(opt => on(opt, 'click', () => {
      if (opt.classList.contains('is-disabled')) return;
      opts.forEach(o => o.classList.remove('is-active'));
      opt.classList.add('is-active');
      const valEl = picker.querySelector('.variant-picker__value');
      if (valEl) valEl.textContent = opt.dataset.value;
      if (input) input.value = opt.dataset.value;
      // Update price
      const priceEl = form ? $('.product-info__price .current', form) : null;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      // Preview this option's image immediately
      if (opt.dataset.image) {
        const main = $('#main-image');
        if (main) main.src = opt.dataset.image;
      }
      syncVariantImage();
    }));
  });

  // ---------- Tabs ----------
  $$('.tabs').forEach(tabs => {
    const buttons = $$('.tab', tabs);
    const panels  = $$(`.tab-panel[data-tab-group="${tabs.dataset.tabGroup}"]`);
    buttons.forEach(btn => on(btn, 'click', () => {
      buttons.forEach(b => b.classList.remove('is-active'));
      panels.forEach(p => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      const target = document.getElementById(btn.dataset.tab);
      target && target.classList.add('is-active');
    }));
  });

  // ---------- Tabbed content (data-tabs) ----------
  $$('[data-tabs]').forEach(group => {
    const tabs = $$('.tabs__tab', group);
    const panels = $$('.tabs__panel', group);
    tabs.forEach(tab => on(tab, 'click', () => {
      const targetId = tab.dataset.tabTarget;
      tabs.forEach(t => t.classList.toggle('is-active', t === tab));
      panels.forEach(p => p.classList.toggle('is-active', p.id === targetId));
    }));
  });

  // ---------- FAQ accordion ----------
  $$('.faq-item__btn').forEach(btn => {
    on(btn, 'click', () => {
      const item = btn.closest('.faq-item');
      item && item.classList.toggle('is-open');
    });
  });

  // ---------- Cart AJAX helpers ----------
  const formatMoney = cents => {
    if (typeof cents !== 'number') return '';
    return (cents / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: Shopify.currency && Shopify.currency.active || 'USD' });
  };

  const refreshCart = () => fetch('/cart.js').then(r => r.json());
  const updateCartCount = count => {
    $$('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  };

  document.addEventListener('ajaxProduct:added', e => {
    updateCartCount(e.detail.cart.item_count);
    openCart();
  });

  // ---------- AJAX add to cart ----------
  $$('form[action="/cart/add"]').forEach(form => {
    on(form, 'submit', async e => {
      e.preventDefault();
      const btn  = $('button[type=submit]', form);
      const orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' } });
        if (!res.ok) throw new Error('Add to cart failed');
        const item = await res.json();
        const cart = await refreshCart();
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { item, cart } }));
        openCart();
      } catch (err) {
        // Fallback: native submit
        form.submit();
      } finally {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
      }
    });
  });

  // ---------- Collection sort ----------
  const sortSelect = $('.collection-sort select');
  if (sortSelect) {
    on(sortSelect, 'change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ---------- Filter chips (visual only – backend uses tags) ----------
  $$('.filter-chip[data-tag]').forEach(chip => {
    on(chip, 'click', () => {
      const tag = chip.dataset.tag;
      const url = new URL(window.location.href);
      const current = url.searchParams.get('filter_tag');
      if (current === tag) url.searchParams.delete('filter_tag');
      else url.searchParams.set('filter_tag', tag);
      window.location.href = url.toString();
    });
  });

  // ---------- Reveal on scroll ----------
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    $$('[data-reveal]').forEach(el => io.observe(el));
  }

  // ---------- Marquee duplicates for seamless loop ----------
  $$('.marquee__track').forEach(track => {
    track.innerHTML += track.innerHTML;
  });

  // ---------- Keyboard shortcut: "/" to focus search ----------
  on(document, 'keydown', e => {
    if (e.key === '/' && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
      e.preventDefault();
      openSearch();
    }
  });

  // ---------- Cart page line remove ----------
  document.addEventListener('click', e => {
    const removeBtn = e.target.closest('.cart-line__remove');
    if (!removeBtn) return;
    e.preventDefault();
    const line = removeBtn.closest('.cart-line');
    const key  = line && line.dataset.lineKey;
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(key, 10), quantity: 0 })
    }).then(() => location.reload());
  });
})();
